// src/catalog/utils/catalogRecent.js

const RECENT_CATALOG_ENTRY_KEY =
  "all_voiced_recent_catalog_entry";

function getEntryId(entry) {
  return entry?._id || entry?.id || null;
}

function buildRecentCatalogEntrySnapshot(entry) {
  if (!entry) {
    return null;
  }

  const entryId = getEntryId(entry);

  if (!entryId && !entry.slug) {
    return null;
  }

  return {
    _id: entry._id,
    id: entry.id,
    slug: entry.slug,
    title: entry.title,
    titleKey: entry.titleKey,
    shortDescription: entry.shortDescription,
    primaryType: entry.primaryType,
    launch: entry.launch,
    savedAt: new Date().toISOString()
  };
}

export function rememberCatalogEntry(entry) {
  if (typeof window === "undefined") {
    return;
  }

  const snapshot =
    buildRecentCatalogEntrySnapshot(entry);

  if (!snapshot) {
    return;
  }

  localStorage.setItem(
    RECENT_CATALOG_ENTRY_KEY,
    JSON.stringify(snapshot)
  );
}

export function getRememberedCatalogEntry() {
  if (typeof window === "undefined") {
    return null;
  }

  const rawValue =
    localStorage.getItem(RECENT_CATALOG_ENTRY_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    localStorage.removeItem(RECENT_CATALOG_ENTRY_KEY);
    return null;
  }
}

export function clearRememberedCatalogEntry() {
  if (typeof window === "undefined") {
    return;
  }

  localStorage.removeItem(RECENT_CATALOG_ENTRY_KEY);
}